import { AxiosResponse } from "axios";
import { FormularioTablaDesarrolloDto } from "../models/formularioTablaDesarrollo";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { UpdateTablaDesarrollo } from "../models/updateTablaDesarrollo";
import { ImportTablaFormDto } from "../models/importTablaFormDto";
import { TasaTablaForm } from "../models/tasaTablaForm";
import { ResponseConsultaTablaDto } from "../models/respuestaConsultaTablaDto";
import { FileDto } from "../../../prepago/interfaces/fileDto";

const generarTablaDesarrollo = async (formulario: FormularioTablaDesarrolloDto) => {
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-mutuo/v1/tablas-desarrollo/generar-tabla-desarrollo`, formulario);
    return response;
}

const obtenerTablaDesarrollo = async (idTabla: number) => {
    const response: Promise<AxiosResponse<FormularioTablaDesarrolloDto>> = axiosInstance.get(`siscred-api-mutuo/v1/tablas-desarrollo/obtener-tabla-desarrollo?tablaDesarrolloId=${idTabla}`);
    return response;
}

const actualizarTablaDesarrollo = async (formulario: UpdateTablaDesarrollo, idTabla: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.patch(`siscred-api-mutuo/v1/tablas-desarrollo/actualizar-tabla-desarrollo/${idTabla}`, formulario);
    return response;
}

const eliminarTablaDesarrollo = async (idTabla: number) => {
    const response: Promise<AxiosResponse> = axiosInstance.delete(`siscred-api-mutuo/v1/tablas-desarrollo/eliminar-tabla-desarrollo/${idTabla}`);
    return response;
}

const importarTablaDesarrollo = async (formulario: ImportTablaFormDto) => {
    const formData = new FormData();
    formData.append("emisor", formulario.emisor);
    formData.append("archivo", formulario.archivo);
    const response: Promise<any> = axiosInstance.post(`siscred-api-mutuo/v1/tablas-desarrollo/importar-tabla-desarrollo`, formData,
        {
            headers: {
                'X-Hide-Toast': 'true',
            }
        }
    );
    return response;
}

const grabarTablaDesarrollo = async (formulario: TasaTablaForm) => {
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-mutuo/v1/tablas-desarrollo/grabar-tabla-desarrollo`, formulario);
    return response;
}

const consultarTablaDesarrollo = async (tablaDesarrolloId: number) => {
    const response: Promise<AxiosResponse<ResponseConsultaTablaDto>> = axiosInstance.get(`siscred-api-mutuo/v1/tablas-desarrollo/consultar-tabla-desarrollo?tablaDesarrolloId=${tablaDesarrolloId}`)
    return response;
}

const exportarTablaDesarrollo = async (tablaDesarrolloId: number) => {
    const response: Promise<AxiosResponse<FileDto>> = axiosInstance.get(`siscred-api-reportes/v1/tablas-desarrollo/exportar?tablaDesarrolloId=${tablaDesarrolloId}`)
    return response;
}

export {generarTablaDesarrollo, obtenerTablaDesarrollo, actualizarTablaDesarrollo, eliminarTablaDesarrollo,
    importarTablaDesarrollo, grabarTablaDesarrollo, consultarTablaDesarrollo, exportarTablaDesarrollo}